import { MapContainer, TileLayer, Circle, useMapEvents } from "react-leaflet";
import "leaflet/dist/leaflet.css";

function ClickToMove({ onPick }) {
  useMapEvents({ click: (e) => onPick(e.latlng) });
  return null;
}

// Proposed excavation area as a centre point + radius (the shape the OneCallAccess API accepts).
export function ExcavationAreaPicker({ area, onChange, readOnly }) {
  if (!area) {
    if (readOnly) return null;
    return (
      <div className="space-y-2" data-testid="bud-area-missing">
        <p className="text-sm text-muted-foreground">This job's site isn't on the map yet. Use your current location if you're on site, or set the site address in Edit Job.</p>
        <button type="button" data-testid="bud-area-use-location" className="h-10 px-4 rounded-md border border-border text-sm font-medium hover:bg-muted"
          onClick={() => navigator.geolocation?.getCurrentPosition((p) => onChange({ lat: +p.coords.latitude.toFixed(6), lng: +p.coords.longitude.toFixed(6), radius_m: 25 }), () => window.alert("Couldn't get your location."))}>
          Use my current location
        </button>
      </div>
    );
  }
  return (
    <div className="space-y-2" data-testid="bud-area-picker">
      <div className="relative z-0 isolate rounded-lg overflow-hidden border border-border h-64 sm:h-80">
        <MapContainer center={[area.lat, area.lng]} zoom={18} className="w-full h-full" dragging={!readOnly} scrollWheelZoom={!readOnly} touchZoom={!readOnly} doubleClickZoom={!readOnly} zoomControl={!readOnly}>
          <TileLayer attribution="&copy; OpenStreetMap contributors" url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
          <Circle center={[area.lat, area.lng]} radius={area.radius_m} pathOptions={{ color: "#FF5F15", fillOpacity: 0.2 }} />
          {!readOnly && <ClickToMove onPick={(p) => onChange({ ...area, lat: +p.lat.toFixed(6), lng: +p.lng.toFixed(6) })} />}
        </MapContainer>
      </div>
      {!readOnly && (
        <label className="flex items-center gap-3 text-sm">
          <span className="whitespace-nowrap">Dig radius <b data-testid="bud-radius-value">{area.radius_m} m</b></span>
          <input type="range" min="5" max="500" step="5" value={area.radius_m} onChange={(e) => onChange({ ...area, radius_m: Number(e.target.value) })}
            className="flex-1 accent-[#FF5F15]" data-testid="bud-radius-input" aria-label="Excavation radius in metres" />
        </label>
      )}
      {!readOnly && <p className="text-xs text-muted-foreground">Tap the map to move the centre of the dig area. Cover the whole area you'll excavate, plus a safety margin.</p>}
    </div>
  );
}
